<template>
	<div>
		<q-table
			ref="table"
			:data="data"
			:columns="columns"
			row-key="id"
			:pagination.sync="server_pagination"
			@request="request"
			:loading="loading"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5,10,50,100]"
			binary-state-sort
			class="q-mt-lg"
			>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
				{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<template slot="body" slot-scope="props">
				<q-tr :props="props">
					<q-td key="title" :props="props">
						{{ props.row.title }}
					</q-td>

					<q-td key="event_date" :props="props">
						{{ fDate(props.row.event_date) }}
					</q-td>

					<q-td key="hr_start" :props="props">
						{{ fHourStart(props.row) }}
					</q-td>

					<q-td key="hr_end" :props="props">
						{{ fHourEnd(props.row) }}
					</q-td>
				</q-tr>
			</template>
		</q-table>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    data() {
        return {
			loading: false,
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns: [
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: false,
                },
                {
                    name: 'event_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'event_date',
                    sortable: false,
                },
                {
                    name: 'hr_start',
                    required: true,
                    label: 'start_time',
                    align: 'left',
                    field: 'hr_start',
                    sortable: false,
                },
                {
                    name: 'hr_end',
                    required: true,
                    label: 'end_time',
                    align: 'left',
                    field: 'hr_end',
                    sortable: false,
				}
            ],
            data: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            selected_user: 'users/selected_user',
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        request({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/admin_users/users/${this.selected_user}/get_user_presential_event_user_scheduled/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.data = response.data.results.map((e) => { return { ...e } })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY'
                    break
                    default: format = 'MM-DD-YYYY'
                    break
                }

                return moment(d).tz('Etc/GMT').format(format)
            }
        },

        fHourStart(d) {
            if (d) return moment(d.hr_start).tz(d.timezone).format('HH:mm:ss')
        },

        fHourEnd(d) {
            if (d) return moment(d.hr_end).tz(d.timezone).format('HH:mm:ss')
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    watch: {
        num_rows: {
            handler (newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()

		this.request({ pagination: this.server_pagination })
	}
}
</script>

<style>

</style>